export const paintings = [
  {
    id: '1',
    title: 'Susurros del Viento',
    titleEn: 'Whispers of the Wind',
    description: 'A study of movement and light in the early morning.',
    descriptionEs: 'Un estudio de movimiento y luz en la madrugada.',
    technique: 'Óleo sobre lienzo',
    size: '120 x 100 cm',
    price: 3500,
    available: false,
    stripe_payment_link: 'https://buy.stripe.com/mock_link_1',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/f9240b71b906a88efaaf371b4d3f5b2c.jpeg'
  },
  {
    id: '2',
    title: 'Tierra Quemada',
    titleEn: 'Scorched Earth',
    description: 'Abstract representation of the harsh summer landscapes.',
    descriptionEs: 'Representación abstracta de los duros paisajes de verano.',
    technique: 'Acrílico y arena sobre tabla',
    size: '150 x 150 cm',
    price: 4200,
    available: false,
    stripe_payment_link: '',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/8a7aebaadcbfc246e6b5d002a58fdf1b.jpeg'
  },
  {
    id: '3',
    title: 'Ecos del Valle',
    titleEn: 'Echoes of the Valley',
    description: 'Soft earthy tones blending into a misty horizon.',
    descriptionEs: 'Suaves tonos terrosos mezclándose en un horizonte brumoso.',
    technique: 'Óleo sobre lienzo',
    size: '90 x 120 cm',
    price: 2800,
    available: true,
    stripe_payment_link: 'https://buy.stripe.com/6oU9ATgxJ2OWcf1fNb1gs03',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/30242684b35e52908e49fc15d8c8bbe1.jpeg'
  },
  {
    id: '4',
    title: 'Luz Filtrada',
    titleEn: 'Filtered Light',
    description: 'Capturing the exact moment sun breaks through the canopy.',
    descriptionEs: 'Capturando el momento exacto en que el sol atraviesa el dosel.',
    technique: 'Técnica mixta',
    size: '100 x 80 cm',
    price: 1900,
    available: true,
    stripe_payment_link: 'https://buy.stripe.com/cNiaEXgxJ9dkfrdfNb1gs02',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/f816a283748ad6bf4a34b0a9bb42e769.jpeg'
  },
  {
    id: '6',
    title: 'Amanecer Gris',
    titleEn: 'Grey Dawn',
    description: 'A striking juxtaposition of vibrant orange against a highly textured, monochromatic background.',
    descriptionEs: 'Una llamativa yuxtaposición de naranja vibrante contra un fondo monocromático y altamente texturizado.',
    technique: 'Técnica mixta sobre tabla',
    size: '80 x 100 cm',
    price: 3200,
    available: true,
    stripe_payment_link: 'https://buy.stripe.com/4gMbJ1epB1KS6UH58x1gs01',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/a387ab8ccb91839155e3e4a7021918cd.jpeg'
  },
  {
    id: '7',
    title: 'Rukeu-urquinaona',
    titleEn: 'Rukeu-urquinaona',
    description: 'Abstract composition with striking contrasting figures against a vibrant, fiery background.',
    descriptionEs: 'Composición abstracta con llamativas figuras en contraste sobre un fondo vibrante y llameante.',
    technique: 'Acrílico sobre lienzo',
    size: '40 x 30 cm',
    price: 1200,
    available: true,
    stripe_payment_link: 'https://buy.stripe.com/14AaEXcht618baX8kJ1gs04',
    image: 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/b5077be071d6d5f204f500e8567f5eb0.jpeg'
  }
];